// Saving a file the API produced.
//
// The export builder moved server-side, so the browser no longer assembles
// bytes: it is handed a short-lived signed URL for the copy of record and saves
// it. The download is still the primary sink — the stored object is the record.
export function downloadUrl(url: string, fileName?: string): void {
  const a = document.createElement('a')
  a.href = url
  if (fileName) a.download = fileName
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
